import { render, staticRenderFns } from "./kepipei.vue?vue&type=template&id=1cacb882&scoped=true"
import script from "./kepipei.vue?vue&type=script&lang=js"
export * from "./kepipei.vue?vue&type=script&lang=js"
import style0 from "./kepipei.vue?vue&type=style&index=0&id=1cacb882&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cacb882",
  null
  
)

export default component.exports